export default __webpack_public_path__ + "static/media/next.9e1d3343.svg";